import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import click from '@mailobj-browser/front/js/events/types/click.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import object from '@mailobj-browser/front/js/utils/object.js'

const onClick = object(listener, {
  type: click,
  task:  (
    { ownerDocument }
  ) => {
    const { defaultView } = ownerDocument
    if (defaultView.opener && defaultView.opener.document) {
      const form = one('form[name="migrationU"]', defaultView.opener.document);
      if (form) {
        form.submit()
      }
    }
    defaultView.close();
  }
})

export default (
  button
) => {
  onClick.listen(button)
}
